export default "__VITE_ASSET__CItxQZBJ__"